import { APP_BAR_HEIGHT } from '@constants';

export const sxStyles = {
  container: {
    backgroundColor: '#FFF',
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },
  loader: {
    alignItems: 'center',
    backgroundColor: 'rgb(255, 255, 255, 0.5)',
    display: 'flex',
    flexDirection: 'column',
    height: `calc(100vh - ${APP_BAR_HEIGHT}px )`,
    justifyContent: 'center',
    width: `calc(100vw - ${230}px)`,
  },
  main: {
    backgroundColor: '#f5f5f5',
    height: '100%',
    marginLeft: `${230}px`,
    px: 8,
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    // mt: `${APP_BAR_HEIGHT}px`,
    overflowY: 'scroll',
    width: '100%',
  },
};
